// DEPENDENCIES
import React from 'react';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

// INNER IMPORTS
import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN } from '../../consts';

// svgs
import yellowMugiscPianoSVG from '../inlineSVGs/yellowMugiscPianoSVG';
import purpleMugicsGuitarNoteSVG from '../inlineSVGs/purpleMugicsGuitarNoteSVG';
import purpleMugicsHeadphonesTieSVG from '../inlineSVGs/purpleMugicsHeadphonesTieSVG';
import dualMugicsGuitarGlassesSVG from '../inlineSVGs/dualMugicsGuitarGlassesSVG';
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';
import whiteLogoSVG from "../inlineSVGs/whiteLogoSVG";

// style
import './ParticipateMobile.css';

const ParticipateMobileModal = props => {

    const handleCloseClick = e => {
        e.stopPropagation();
        props.closeModal();
    }

    return (
        <div className="participate">
            <Modal
                isOpen={props.isModalOpen}
                contentLabel="Participate"
                className="modal-wrapper participate-mobile"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.85)'
                    }
                }}
            >
                <SVGInline svg={whiteLogoSVG} component="i" className="icon-white-logo"/>
                <h1 className="title">עושים סדר בעולם המוזיקה</h1>

                <div className={`content rtl ${SERVICE}`} onClick={() => props.openSubmitModalRequest(SERVICE)}>
                    <div className="close-btn" onClick={e => handleCloseClick(e)}>
                        <SVGInline svg={closeCrossSVG} component="i"/>
                    </div>

                    <SVGInline svg={purpleMugicsHeadphonesTieSVG} width={90} component="i" className="icon-wrapper service"/>
                    <div className="text">
                        {props.textService}
                    </div>
                </div>

                <div className={`content rtl ${LIVE_MUSIC}`} onClick={() => props.openSubmitModalRequest(LIVE_MUSIC)}>
                    <SVGInline svg={yellowMugiscPianoSVG} width={65} component="i" className="icon-wrapper"/>
                    <div className="text">
                        {props.textLiveMusic}
                    </div>
                </div>

                <div className={`content rtl ${MUSICIAN}`} onClick={() => props.openSubmitModalRequest(MUSICIAN)}>
                    <SVGInline svg={purpleMugicsGuitarNoteSVG} component="i" className="icon-wrapper musician"/>
                    <div className="text">
                        {props.textMusician}
                    </div>
                </div>

                <div className={`content rtl ${BAND}`} onClick={() => props.openSubmitModalRequest(BAND)}>
                    <SVGInline svg={dualMugicsGuitarGlassesSVG} component="i" className="icon-wrapper band"/>
                    <div className="text">
                        {props.textBand}
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ParticipateMobileModal;



// WEBPACK FOOTER //
// ./src/Components/Users/ParticipateMobile.js